import { Button, Modal, ModalBody, ModalContent, ModalFooter, ModalHeader } from '@heroui/react'
import { FiAlertTriangle } from 'react-icons/fi'

export default function ConfirmRemoveModal({
  isOpen,
  onClose,
  phoneNumber,
  onConfirm,
  isLoading = false,
}) {
  if (!phoneNumber)
    return null

  const handleConfirm = () => {
    onConfirm?.()
  }

  const handleClose = () => {
    if (!isLoading) {
      onClose?.()
    }
  }

  return (
    <Modal
      isOpen={isOpen}
      onClose={handleClose}
      size="md"
      closeButton={!isLoading}
      isDismissable={!isLoading}
    >
      <ModalContent>
        <ModalHeader className="flex flex-col gap-1">
          <div className="flex items-center gap-2">
            <FiAlertTriangle className="text-red-500" size={20} />
            <span>Remove BYOT Number</span>
          </div>
        </ModalHeader>

        <ModalBody>
          <div className="flex flex-col gap-y-3">
            <p className="text-sm text-gray-600">
              Are you sure you want to remove
              {' '}
              <strong className="text-gray-900">{phoneNumber}</strong>
              {' '}
              from Bland?
            </p>

            <div className="rounded-lg border border-red-200 bg-red-50 p-3">
              <p className="text-sm text-red-700">
                <strong>Warning:</strong>
                {' '}
                This action cannot be undone. The number will be
                removed from your account and all associated configurations will be lost.
              </p>
            </div>
          </div>
        </ModalBody>

        <ModalFooter>
          <Button
            variant="light"
            onPress={handleClose}
            disabled={isLoading}
            className="mr-2"
          >
            Cancel
          </Button>
          <Button
            color="danger"
            onPress={handleConfirm}
            isLoading={isLoading}
            disabled={isLoading}
          >
            {isLoading ? 'Removing...' : 'Remove Number'}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}
